import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-828dfd66")

_pushScopeId("data-v-828dfd66")
const _hoisted_1 = { class: "Check" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["Check__input", {
        'Check__input--checked': _ctx.state,
      }],
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.onClick(...args)), ["stop"]))
    }, null, 2)
  ]))
})